import { AlertSettingToggle } from "./AlertSettingToggle";

export const AlertAboveGoalToggle = (props) => (
  <AlertSettingToggle {...props} setting="alert_above_goal" />
);
